module.exports = __webpack_public_path__ + "static/media/sexo.8af45889.svg";